<p class="step-subtitle" *ngIf="type === manageBuildingTypes.Add">
  {{ "add-building" | translate }}
</p>
<p class="step-subtitle" *ngIf="type === manageBuildingTypes.Update">
  {{ "edit-building" | translate }}
</p>

<mat-horizontal-stepper *ngIf="formInitialized" class="horizontal-stepper" labelPosition="bottom" #stepper>
  <mat-step [stepControl]="basicGroup" matTooltip="{{ 'details' | translate }}"
    *ngIf="type == manageBuildingTypes.Details || (isCategoryValid(buildingCategories.BasicInfo) || isCategoryValid(buildingCategories.Energy) || isCategoryValid(buildingCategories.Geometry))">
    <ng-template matStepLabel matStepperIcon="phone"><span class="wrapped-span">{{
        "details" | translate
        }}</span></ng-template>

    <div *ngIf="type!==manageBuildingTypes.Details && isCategoryValid(buildingCategories.BasicInfo)">
      <p class="step-subtitle">{{ "details" | translate }}</p>

      <form [formGroup]="basicGroup">
        <mat-form-field>
          <mat-label>{{ "yearOfBuild" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            (click)="constructionPicker.open()" [placeholder]="'yearOfBuild' | translate" matInput
            matTooltip="{{ 'yearOfBuild' | translate }}" [matDatepicker]="constructionPicker"
            formControlName="construction" />
          <mat-datepicker-toggle matSuffix [for]="constructionPicker"
            [disabled]="type === manageBuildingTypes.Details || !isAdministrator"></mat-datepicker-toggle>
          <mat-datepicker [disabled]="type === manageBuildingTypes.Details || !isAdministrator" startView="multi-year"
            (yearSelected)="periodConstructionSelected($event); constructionPicker.close()" #constructionPicker>
          </mat-datepicker>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "longitude" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'longitude' | translate }}" type="number" matInput formControlName="longitude" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "latitude" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'latitude' | translate }}" matInput type="number" formControlName="latitude" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "street" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'street' | translate }}" matInput formControlName="street" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "street-number" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'street-number' | translate }}" matInput formControlName="streetNumber" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "municipality" | translate }}</mat-label>
          <mat-select [disabled]="type === manageBuildingTypes.Details" matTooltip="{{ 'municipality' | translate }}"
            matInput formControlName="municipalityId">
            <mat-option *ngFor="let man of municipalities" [value]="man.id">
              {{ man.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </div>

    <div *ngIf="type == manageBuildingTypes.Details || isCategoryValid(buildingCategories.Energy)">
      <p class="step-subtitle">{{ "energy" | translate }}</p>

      <form [formGroup]="energyGroup">
        <mat-form-field>
          <mat-label>{{ "buildingEnergyClass" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'buildingEnergyClass-tooltip' | translate }}" matInput
            formControlName="buildingEnergyClass" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{
            "buildingEnergyClassAfterAllMeasures" | translate
            }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'buildingEnergyClassAfterAllMeasures-tooltip' | translate }}" matInput
            formControlName="buildingEnergyClassAfterAllMeasures" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ "yearlyRequredEnergyPerM2" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'yearlyRequredEnergyPerM2-tooltip' | translate }}" matInput type="decimal"
            formControlName="yearlyRequredEnergyPerM2" />
          <span matSuffix>{{ "energy-prefix" | translate }}</span>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{
            "yearlyRequredEnergyPerM2AfterAllMeasures" | translate
            }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator" matTooltip="{{
              'yearlyRequredEnergyPerM2AfterAllMeasures-tooltip' | translate
            }}" matInput type="decimal" formControlName="yearlyRequredEnergyPerM2AfterAllMeasures" />
          <span matSuffix>{{ "energy-prefix" | translate }}</span>
        </mat-form-field>
      </form>
    </div>

    <div *ngIf="type == manageBuildingTypes.Details || isCategoryValid(buildingCategories.Geometry)">
      <p class="step-subtitle">{{ "geometry" | translate }}</p>

      <form [formGroup]="geometryGroup">
        <mat-form-field>
          <mat-label>{{ "area" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'area' | translate }}" type="number" matInput formControlName="area" />
          <span matSuffix>{{ "square-meters" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "basePerimetar" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'basePerimetar' | translate }}" type="number" matInput formControlName="basePerimetar" />
          <span matSuffix>{{ "square-meters" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "floors" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'floors' | translate }}" matInput formControlName="floors" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "facadeArea" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'facadeArea' | translate }}" type="decimal" matInput formControlName="facadeArea" />
          <span matSuffix>{{ "square-meters" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "windowArea" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'windowArea' | translate }}" type="number" matInput formControlName="windowArea" requred />
          <span matSuffix>{{ "square-meters" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "basement" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'basement' | translate }}" matInput formControlName="basement" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "heatedBases" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'heatedBases' | translate }}" type="number" matInput formControlName="heatedBases" />
          <span matSuffix>{{ "square-meters" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "volume" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'volume' | translate }}" type="number" matInput formControlName="volume" />
          <span matSuffix>{{ "cubic-meters" | translate }}</span>
        </mat-form-field>
      </form>
    </div>

    <div class="full-width-flex">
      <div class="margin-left-auto">
        <button *ngIf="isAuthorized" color="primary" mat-raised-button (click)="goToDetails()"
          [disabled]="type !== manageBuildingTypes.Details && (!basicGroup.valid || !geometryGroup.valid)">
          {{ "next" | translate }}
        </button>
      </div>
    </div>
  </mat-step>

  <mat-step *ngIf="((isAuthorized || isVeles || isGjorcePetrov) ||
  (isCategoryValid(buildingCategories.RabaBasic) ||
  isCategoryValid(buildingCategories.RabaGeometry) ||
  isCategoryValid(buildingCategories.RabaFunctionality) ||
  isCategoryValid(buildingCategories.RabaArchitecture) ||
  isCategoryValid(buildingCategories.RabaOtherInfo)))" [stepControl]="detailsGroup">
    <ng-template matStepLabel><span class="wrapped-span">{{ "more" | translate }}</span></ng-template>

    <form [formGroup]="detailsGroup">
      <div *ngIf="isCategoryValid(buildingCategories.RabaBasic)">
        <p class="step-subtitle">{{ "managing-data" | translate }}</p>
        <mat-form-field>
          <mat-label>{{ "archiveDate" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'archiveDate' | translate }}" matInput formControlName="archiveDate" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "apartments" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'apartments' | translate }}" type="number" matInput formControlName="apartments" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "apartmentsForRent" | translate }}</mat-label>
          <input matTooltip="{{ 'apartmentsForRent' | translate }}" type="number" matInput
            formControlName="apartmentsForRent" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "lastYearRenovation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'lastYearRenovation' | translate }}" matInput formControlName="lastYearRenovation" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "partInPercentage" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'partInPercentage' | translate }}" matInput formControlName="partInPercentage" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "buildingManagementType" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'buildingManagementType' | translate }}" matInput formControlName="buildingManagementType" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "managementContact" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'managementContact' | translate }}" matInput formControlName="managementContact" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "archiveNumber1" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator" matInput
            formControlName="archiveNumber1" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "archiveDate1" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'archiveDate1' | translate }}" matInput formControlName="archiveDate1" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "managementName" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'managementName' | translate }}" matInput formControlName="managementName" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "municipality1" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'municipality1' | translate }}" matInput formControlName="municipality1" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "region" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'region' | translate }}" matTooltip="{{ 'region' | translate }}" matInput
            formControlName="region" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "addressStreet1" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'addressStreet1' | translate }}" matTooltip="{{ 'addressStreet1' | translate }}" matInput
            formControlName="addressStreet1" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "addressNumber1" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'addressNumber1' | translate }}" matInput formControlName="addressNumber1" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "contractNumber" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'contractNumber' | translate }}" matInput formControlName="contractNumber" />
        </mat-form-field>
      </div>

      <div *ngIf="isCategoryValid(buildingCategories.RabaGeometry)">
        <p class="step-subtitle">{{ "geometric-data" | translate }}</p>
        <mat-form-field>
          <mat-label>{{ "height" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'height' | translate }}" matInput formControlName="height" type="decimal" />
          <span matSuffix>{{ "metres" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "length" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'length' | translate }}" matInput formControlName="length" type="decimal" />
          <span matSuffix>{{ "metres" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "width" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'width' | translate }}" matInput formControlName="width" type="decimal" />
          <span matSuffix>{{ "metres" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "entrances" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'entrances' | translate }}" matInput type="number" formControlName="entrances" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "apartmentsByFloor" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'apartmentsByFloor' | translate }}" matInput formControlName="apartmentsByFloor" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "apartmentArea" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'apartmentArea' | translate }}" matInput formControlName="apartmentArea" />
        </mat-form-field>
      </div>

      <div *ngIf="isCategoryValid(buildingCategories.RabaFunctionality)">
        <p class="step-subtitle">{{ "functional-data" | translate }}</p>
        <mat-form-field>
          <mat-label>{{ "emptyApartments" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'emptyApartments' | translate }}" matInput formControlName="emptyApartments" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "officeSpace" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'officeSpace' | translate }}" matInput formControlName="officeSpace" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "officeSpaceDescription" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'officeSpaceDescription' | translate }}" matInput formControlName="officeSpaceDescription" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "hasElevator" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'hasElevator' | translate }}" matInput formControlName="hasElevator" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "elevatorDescription" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'elevatorDescription' | translate }}" matInput formControlName="elevatorDescription" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "elevatorState" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'elevatorState' | translate }}" matInput formControlName="elevatorState" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "elevatorMaintenanceCompany" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'elevatorMaintenanceCompany' | translate }}" matInput
            formControlName="elevatorMaintenanceCompany" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{
            "elevatorMaintenanceCompanyContact" | translate
            }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'elevatorMaintenanceCompanyContact' | translate }}" matInput
            formControlName="elevatorMaintenanceCompanyContact" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "hasCommonSpace" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'hasCommonSpace' | translate }}" matInput formControlName="hasCommonSpace" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "commonSpaceDescription" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'commonSpaceDescription' | translate }}" matInput formControlName="commonSpaceDescription" />
        </mat-form-field>
      </div>

      <div *ngIf="isCategoryValid(buildingCategories.RabaArchitecture)">
        <p class="step-subtitle">{{ "arch-build-data" | translate }}</p>
        <mat-form-field>
          <mat-label>{{ "isLandPrivatize" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'isLandPrivatize' | translate }}" matInput formControlName="isLandPrivatize" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "wallsType" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'wallsType' | translate }}" matInput formControlName="wallsType" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "constructionBetweenFloors" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'constructionBetweenFloors' | translate }}" matInput
            formControlName="constructionBetweenFloors" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "roofType" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'roofType' | translate }}" matInput formControlName="roofType" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "roofCovering" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'roofCovering' | translate }}" matInput formControlName="roofCovering" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "northBuildingArea" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'northBuildingArea' | translate }}" matInput formControlName="northBuildingArea" />
          <span matSuffix>{{ "square-meters" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "southBuildingArea" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'southBuildingArea' | translate }}" matInput formControlName="southBuildingArea" />
          <span matSuffix>{{ "square-meters" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "eastBuildingArea" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'eastBuildingArea' | translate }}" matInput formControlName="eastBuildingArea" />
          <span matSuffix>{{ "square-meters" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "westBuildingArea" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'westBuildingArea' | translate }}" matInput formControlName="westBuildingArea" />
          <span matSuffix>{{ "square-meters" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "roofState" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'roofState' | translate }}" matInput formControlName="roofState" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "facadeState" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'facadeState' | translate }}" matInput formControlName="facadeState" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "windowsState" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'windowsState' | translate }}" matInput formControlName="windowsState" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "entranceDoorState" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'entranceDoorState' | translate }}" matInput formControlName="entranceDoorState" />
        </mat-form-field>
      </div>

      <div *ngIf="isCategoryValid(buildingCategories.RabaOtherInfo)">
        <p class="step-subtitle">{{ "otherDetails" | translate }}</p>
        <mat-form-field>
          <mat-label>{{ "waysOfHeating" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'waysOfHeating' | translate }}" matInput formControlName="waysOfHeating" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{
            "aparmentsExcludedFromCentralHeating" | translate
            }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'aparmentsExcludedFromCentralHeating' | translate }}" matInput
            formControlName="aparmentsExcludedFromCentralHeating" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "hasAntiFireLaddersAndWorks" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'hasAntiFireLaddersAndWorks' | translate }}" matInput
            formControlName="hasAntiFireLaddersAndWorks" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "hasHydrantAndWorks" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'hasHydrantAndWorks' | translate }}" matInput formControlName="hasHydrantAndWorks" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "hasAntiFireDeviceAndWorks" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'hasAntiFireDeviceAndWorks' | translate }}" matInput
            formControlName="hasAntiFireDeviceAndWorks" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "hasSsrPeople" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'hasSsrPeople' | translate }}" matInput formControlName="hasSsrPeople" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "ssrPeople" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'ssrPeople' | translate }}" type="number" matInput formControlName="ssrPeople" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "accessRampForSsrPeople" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'accessRampForSsrPeople' | translate }}" matInput formControlName="accessRampForSsrPeople" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "hasLightningRod" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'hasLightningRod' | translate }}" matInput formControlName="hasLightningRod" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "isOkLightningRod" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'isOkLightningRod' | translate }}" matInput formControlName="isOkLightningRod" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "notes" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'notes' | translate }}" matInput formControlName="notes" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "responsibleDataPerson" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'responsibleDataPerson' | translate }}" matInput formControlName="responsibleDataPerson" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "yearOfBuild" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'yearOfBuild' | translate }}" matInput formControlName="yearOfBuild" />
        </mat-form-field>
      </div>


      <div class="full-width-flex">
        <div class="margin-left-auto">
          <button *ngIf="isAuthorized" mat-raised-button matStepperPrevious>
            {{ "back" | translate }}
          </button>
          <button *ngIf="isAuthorized" color="primary" mat-raised-button [disabled]="
              type !== manageBuildingTypes.Details && !detailsGroup.valid
            " (click)="goToTransmission()">
            {{ "next" | translate }}
          </button>
        </div>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="cO2Group"
    *ngIf="(isAuthorized || isVeles || isGjorcePetrov) && (isCategoryValid(buildingCategories.CO2) || isCategoryValid(buildingCategories.CO) || isCategoryValid(buildingCategories.Dust) || isCategoryValid(buildingCategories.NMVOC) || isCategoryValid(buildingCategories.Nox) || isCategoryValid(buildingCategories.SO2))">
    <ng-template matStepLabel><span class="wrapped-span">{{
        "yearly-transmission" | translate
        }}</span></ng-template>

    <div *ngIf="isCategoryValid(buildingCategories.CO2)">
      <p class="step-subtitle">CO2</p>

      <form [formGroup]="cO2Group">
        <mat-form-field>
          <mat-label>{{ "transmision" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'transmision' | translate }}" type="decimal" matInput formControlName="transmision" />
          <span matSuffix>{{ "ton-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByWallsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByWallsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByWallsIsolation" />
          <span matSuffix>{{ "ton-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByRoofsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByRoofsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByRoofsIsolation" />
          <span matSuffix>{{ "ton-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByWindowsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByWindowsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByWindowsIsolation" />
          <span matSuffix>{{ "ton-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByGroundIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByGroundIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByGroundIsolation" />
          <span matSuffix>{{ "ton-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "sumDecrease" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'sumDecrease-tooltip' | translate }}" type="decimal" matInput
            formControlName="sumDecrease" />
          <span matSuffix>{{ "ton-unit" | translate }}</span>
        </mat-form-field>
      </form>
    </div>

    <div *ngIf="isCategoryValid(buildingCategories.CO)">
      <p class="step-subtitle">CO</p>

      <form [formGroup]="coGroup">
        <mat-form-field>
          <mat-label>{{ "transmision" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'transmision' | translate }}" type="decimal" matInput formControlName="transmision" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByWallsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByWallsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByWallsIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByRoofsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByRoofsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByRoofsIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByWindowsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByWindowsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByWindowsIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByGroundIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByGroundIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByGroundIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "sumDecrease" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'sumDecrease-tooltip' | translate }}" type="decimal" matInput
            formControlName="sumDecrease" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>
      </form>
    </div>

    <div *ngIf="isCategoryValid(buildingCategories.Dust)">
      <p class="step-subtitle">{{ "dust" | translate }}</p>

      <form [formGroup]="dustGroup">
        <mat-form-field>
          <mat-label>{{ "transmision" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'transmision' | translate }}" type="decimal" matInput formControlName="transmision" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByWallsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByWallsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByWallsIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByRoofsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByRoofsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByRoofsIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByWindowsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByWindowsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByWindowsIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByGroundIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByGroundIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByGroundIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "sumDecrease" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'sumDecrease-tooltip' | translate }}" type="decimal" matInput
            formControlName="sumDecrease" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>
      </form>
    </div>

    <div *ngIf="isCategoryValid(buildingCategories.NMVOC)">
      <p class="step-subtitle">Nvmoc</p>

      <form [formGroup]="nmvocGroup">
        <mat-form-field>
          <mat-label>{{ "transmision" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'transmision' | translate }}" type="decimal" matInput formControlName="transmision" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByWallsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByWallsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByWallsIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByRoofsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByRoofsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByRoofsIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByWindowsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByWindowsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByWindowsIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByGroundIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByGroundIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByGroundIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "sumDecrease" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'sumDecrease-tooltip' | translate }}" type="decimal" matInput
            formControlName="sumDecrease" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>
      </form>
    </div>

    <div *ngIf="isCategoryValid(buildingCategories.Nox)">
      <p class="step-subtitle">NOX</p>
      <form [formGroup]="noxGroup">
        <mat-form-field>
          <mat-label>{{ "transmision" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'transmision' | translate }}" type="decimal" matInput formControlName="transmision" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByWallsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByWallsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByWallsIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByRoofsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByRoofsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByRoofsIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByWindowsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByWindowsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByWindowsIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByGroundIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByGroundIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByGroundIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "sumDecrease" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'sumDecrease-tooltip' | translate }}" type="decimal" matInput
            formControlName="sumDecrease" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>
      </form>
    </div>

    <div *ngIf="isCategoryValid(buildingCategories.SO2)">
      <p class="step-subtitle">SO2</p>

      <form [formGroup]="so2Group">
        <mat-form-field>
          <mat-label>{{ "transmision" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'transmision' | translate }}" type="decimal" matInput formControlName="transmision" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByWallsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByWallsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByWallsIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByRoofsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByRoofsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByRoofsIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByWindowsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByWindowsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByWindowsIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "decreaseByGroundIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'decreaseByGroundIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="decreaseByGroundIsolation" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "sumDecrease" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'sumDecrease-tooltip' | translate }}" type="decimal" matInput
            formControlName="sumDecrease" />
          <span matSuffix>{{ "kilogram-unit" | translate }}</span>
        </mat-form-field>
      </form>
    </div>

    <div class="full-width-flex">
      <div class="margin-left-auto">
        <button *ngIf="isAuthorized" mat-raised-button matStepperPrevious>
          {{ "back" | translate }}
        </button>
        <button *ngIf="isAuthorized" color="primary" mat-raised-button (click)="goToInvestment()"
          [disabled]="type !== manageBuildingTypes.Details && !so2Group.valid">
          {{ "next" | translate }}
        </button>
      </div>
    </div>
  </mat-step>

  <mat-step *ngIf="(isAuthorized || isVeles || isGjorcePetrov) && isCategoryValid(buildingCategories.Investment)"
    [stepControl]="investmentGroup">
    <ng-template matStepLabel><span class="wrapped-span">{{
        "investment" | translate
        }}</span></ng-template>

    <div>
      <p class="step-subtitle">
        {{ "investment" | translate }}
      </p>

      <form [formGroup]="investmentGroup">
        <mat-form-field>
          <mat-label>{{ "wallsInvestment" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'wallsInvestment-tooltip' | translate }}" type="decimal" matInput
            formControlName="wallsInvestment" />
          <span matSuffix>{{ "price-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "roofsInvestment" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'roofsInvestment-tooltip' | translate }}" type="decimal" matInput
            formControlName="roofsInvestment" />
          <span matSuffix>{{ "price-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "windowsInvestment" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'windowsInvestment-tooltip' | translate }}" type="decimal" matInput
            formControlName="windowsInvestment" />
          <span matSuffix>{{ "price-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "groundInvestment" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'groundInvestment-tooltip' | translate }}" type="decimal" matInput
            formControlName="groundInvestment" />
          <span matSuffix>{{ "price-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "sumInvestment" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'sumInvestment' | translate }}" type="decimal" matInput formControlName="sumInvestment" />
          <span matSuffix>{{ "price-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "unitPriceForWallIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'unitPriceForWallIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="unitPriceForWallIsolation" />
          <span matSuffix>{{ "price-unit-square" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "unitPriceForRoofsIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'unitPriceForRoofsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="unitPriceForRoofsIsolation" />
          <span matSuffix>{{ "price-unit-square" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{
            "unitPriceForWindowsIsolation" | translate
            }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'unitPriceForWindowsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="unitPriceForWindowsIsolation" />
          <span matSuffix>{{ "price-unit-square" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "unitPriceForGroundIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'unitPriceForGroundIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="unitPriceForGroundIsolation" />
          <span matSuffix>{{ "price-unit-square" | translate }}</span>
        </mat-form-field>
      </form>
    </div>

    <div class="full-width-flex">
      <div class="margin-left-auto">
        <button *ngIf="isAuthorized" mat-raised-button matStepperPrevious>
          {{ "back" | translate }}
        </button>
        <button *ngIf="isAuthorized" color="primary" mat-raised-button (click)="goToMoneySaving()" [disabled]="
            type !== manageBuildingTypes.Details && !investmentGroup.valid
          ">
          {{ "next" | translate }}
        </button>
      </div>
    </div>
  </mat-step>

  <mat-step *ngIf="(isAuthorized || isVeles || isGjorcePetrov) && isCategoryValid(buildingCategories.MoneySaving)"
    [stepControl]="moneySavingGroup">

    <ng-template matStepLabel matStepperIcon="phone"><span class="wrapped-span">
        {{ "yearly-money-savings" | translate }}
      </span></ng-template>

    <p class="step-subtitle">
      {{ "yearly-money-savings" | translate }}
    </p>

    <form [formGroup]="moneySavingGroup">
      <mat-form-field>
        <mat-label>{{ "heatingCost" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'heatingCost-tooltip' | translate }}" type="decimal" matInput formControlName="heatingCost" />
        <span matSuffix>{{ "energy-per-meter" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "heatingCostPerArea" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'heatingCostPerArea-tooltip' | translate }}" type="decimal" matInput
          formControlName="heatingCostPerArea" />
        <span matSuffix>{{ "energy-per-meter" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "wallsSaving" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'wallsSaving-tooltip' | translate }}" type="decimal" matInput formControlName="wallsSaving" />
        <span matSuffix>{{ "energy-per-meter" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "wallsSavingPerArea" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'wallsSavingPerArea-tooltip' | translate }}" type="decimal" matInput
          formControlName="wallsSavingPerArea" />
        <span matSuffix>{{ "energy-per-meter" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "roofSaving" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'roofSaving-tooltip' | translate }}" type="decimal" matInput formControlName="roofSaving" />
        <span matSuffix>{{ "energy-per-meter" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "roofSavingPerArea" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'roofSavingPerArea-tooltip' | translate }}" type="decimal" matInput
          formControlName="roofSavingPerArea" />
        <span matSuffix>{{ "energy-per-meter" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "windowsSaving" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'windowsSaving-tooltip' | translate }}" type="decimal" matInput
          formControlName="windowsSaving" />
        <span matSuffix>{{ "energy-per-meter" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "windowsSavingPerArea" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'windowsSavingPerArea-tooltip' | translate }}" type="decimal" matInput
          formControlName="windowsSavingPerArea" />
        <span matSuffix>{{ "energy-per-meter" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "groundSaving" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'groundSaving-tooltip' | translate }}" type="decimal" matInput
          formControlName="groundSaving" />
        <span matSuffix>{{ "energy-per-meter" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "groundSavingPerArea" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'groundSavingPerArea-tooltip' | translate }}" type="decimal" matInput
          formControlName="groundSavingPerArea" />
        <span matSuffix>{{ "energy-per-meter" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "sumSaving" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'sumSaving' | translate }}" type="decimal" matInput formControlName="sumSaving" />
        <span matSuffix>{{ "energy-per-meter" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "sumSavingPerArea" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'sumSavingPerArea-tooltip' | translate }}" type="decimal" matInput
          formControlName="sumSavingPerArea" />
        <span matSuffix>{{ "energy-per-meter" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "energyPrice" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'energyPrice' | translate }}" type="decimal" matInput formControlName="energyPrice" />
        <span matSuffix>{{ "energy-per-meter" | translate }}</span>
      </mat-form-field>

      <div class="full-width-flex">
        <div class="margin-left-auto">
          <button *ngIf="isAuthorized" mat-raised-button matStepperPrevious>
            {{ "back" | translate }}
          </button>
          <button *ngIf="isAuthorized" color="primary" mat-raised-button (click)="goToConsumption()" [disabled]="
              type !== manageBuildingTypes.Details && !moneySavingGroup.valid
            ">
            {{ "next" | translate }}
          </button>
        </div>
      </div>
    </form>
  </mat-step>

  <mat-step *ngIf="(isAuthorized || isVeles || isGjorcePetrov) && (isCategoryValid(buildingCategories.BuildingYearlyTermalEnergySaving))"
    [stepControl]="consumationGroup">

    <ng-template matStepLabel matStepperIcon="phone"><span class="wrapped-span">
        {{ "energy-characteristics" | translate }}
      </span></ng-template>

    <p class="step-subtitle">
      {{ "energy-characteristics" | translate }}
    </p>

    <form [formGroup]="consumationGroup">
      <mat-form-field>
        <mat-label>{{ "yearlyRequredEnergy" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'yearlyRequredEnergy-tooltip' | translate }}" type="decimal" matInput
          formControlName="yearlyRequredEnergy" />
        <span matSuffix>{{ "energy-prefix" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "wallsIsolationSaving" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'wallsIsolationSaving-tooltip' | translate }}" type="decimal" matInput
          formControlName="wallsIsolationSaving" />
        <span matSuffix>{{ "energy-prefix" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "roofsIsolationSaving" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'roofsIsolationSaving-tooltip' | translate }}" type="decimal" matInput
          formControlName="roofsIsolationSaving" />
        <span matSuffix>{{ "energy-prefix" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "windowsIsolationSaving" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'windowsIsolationSaving-tooltip' | translate }}" type="decimal" matInput
          formControlName="windowsIsolationSaving" />
        <span matSuffix>{{ "energy-prefix" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "groundIsolationSaving" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'groundIsolationSaving-tooltip' | translate }}" type="decimal" matInput
          formControlName="groundIsolationSaving" />
        <span matSuffix>{{ "energy-prefix" | translate }}</span>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "sumIsolationSaving" | translate }}</mat-label>
        <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
          matTooltip="{{ 'sumIsolationSaving-tooltip' | translate }}" type="decimal" matInput
          formControlName="sumIsolationSaving" />
        <span matSuffix>{{ "energy-prefix" | translate }}</span>
      </mat-form-field>

      <div class="full-width-flex">
        <div class="margin-left-auto">
          <button *ngIf="isAuthorized" mat-raised-button matStepperPrevious>
            {{ "back" | translate }}
          </button>
          <button *ngIf="isAuthorized" color="primary" mat-raised-button (click)="goToProfitability()" [disabled]="
              type !== manageBuildingTypes.Details && !consumationGroup.valid
            ">
            {{ "next" | translate }}
          </button>
        </div>
      </div>
    </form>
  </mat-step>

  <mat-step
    *ngIf="(isAuthorized || isVeles || isGjorcePetrov) && (isCategoryValid(buildingCategories.Profitability) || isCategoryValid(buildingCategories.PricePerInvestment))"
    [stepControl]="profitabilityGroup">

    <ng-template matStepLabel matStepperIcon="phone"><span class="wrapped-span">
        {{ "payment-analyze" | translate }}
      </span></ng-template>

    <div *ngIf="isCategoryValid(buildingCategories.Profitability)">
      <p class="step-subtitle">{{ "payment-analyze" | translate }}</p>

      <form [formGroup]="profitabilityGroup">

        <mat-form-field>
          <mat-label>{{
            "returnPeriodForWallIsolation" | translate
            }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'eturnPeriodForWallIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="returnPeriodForWallIsolation" />
          <span matSuffix>{{ "year-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "yieldRateForWallIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'yieldRateForWallIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="yieldRateForWallIsolation" />
          <span matSuffix>{{ "percentage-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{
            "returnPeriodForRoofIsolation" | translate
            }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'returnPeriodForRoofIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="returnPeriodForRoofIsolation" />
          <span matSuffix>{{ "year-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "yieldRateForRoofIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'yieldRateForRoofIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="yieldRateForRoofIsolation" />
          <span matSuffix>{{ "percentage-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{
            "returnPeriodForWindowsIsolation" | translate
            }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'returnPeriodForWindowsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="returnPeriodForWindowsIsolation" />
          <span matSuffix>{{ "year-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{
            "yieldRateForWindowsIsolation" | translate
            }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'yieldRateForWindowsIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="yieldRateForWindowsIsolation" />
          <span matSuffix>{{ "percentage-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{
            "returnPeriodForGroundIsolation" | translate
            }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'returnPeriodForGroundIsolation-tooltip' | translate }}" type="decimal" matInput
            formControlName="returnPeriodForGroundIsolation" />
          <span matSuffix>{{ "year-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "yieldRateForGroundIsolation" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'yieldRateForGroundIsolation-tooltip' | translate }}" type="number" matInput
            formControlName="yieldRateForGroundIsolation" />
          <span matSuffix>{{ "percentage-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "returnPeriodForAllMeasures" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'returnPeriodForAllMeasures-tooltip' | translate }}" type="decimal" matInput
            formControlName="returnPeriodForAllMeasures" />
          <span matSuffix>{{ "year-unit" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "yieldRateForAllMeasures" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'yieldRateForAllMeasures-tooltip' | translate }}" type="decimal" matInput
            formControlName="yieldRateForAllMeasures" />
          <span matSuffix>{{ "percentage-unit" | translate }}</span>
        </mat-form-field>
      </form>
    </div>

    <div *ngIf="isCategoryValid(buildingCategories.PricePerInvestment)">
      <p class="step-subtitle">
        {{ "pricePerInvestmentGroup" | translate }}
      </p>

      <form [formGroup]="pricePerInvestmentGroup">
        <ng-template matStepLabel><span class="wrapped-span">
            {{ "pricePerInvestmentGroup" | translate }}</span></ng-template>
        <mat-form-field>
          <mat-label>{{ "costOfSavedKWhWalls" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'costOfSavedKWhWalls-tooltip' | translate }}" type="decimal" matInput
            formControlName="costOfSavedKWhWalls" />
          <span matSuffix>{{ "meter-per-kwh" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "costOfSavedKWhRoof" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'costOfSavedKWhRoof-tooltip' | translate }}" type="decimal" matInput
            formControlName="costOfSavedKWhRoof" />
          <span matSuffix>{{ "meter-per-kwh" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "costOfSavedKWhFloors" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'costOfSavedKWhFloors-tooltip' | translate }}" type="decimal" matInput
            formControlName="costOfSavedKWhFloors" />
          <span matSuffix>{{ "meter-per-kwh" | translate }}</span>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ "costOfSavedKWhWindows" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'costOfSavedKWhWindows-tooltip' | translate }}" type="decimal" matInput
            formControlName="costOfSavedKWhWindows" />
          <span matSuffix>{{ "meter-per-kwh" | translate }}</span>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "costOfSavedKWhAllMeasures" | translate }}</mat-label>
          <input [readonly]="type === manageBuildingTypes.Details || !isAdministrator"
            matTooltip="{{ 'costOfSavedKWhAllMeasures-tooltip' | translate }}" type="decimal" matInput
            formControlName="costOfSavedKWhAllMeasures" />
          <span matSuffix>{{ "meter-per-kwh" | translate }}</span>
        </mat-form-field>
      </form>
    </div>

    <div class="full-width-flex">
      <div class="margin-left-auto">
        <button *ngIf="isAuthorized" mat-raised-button matStepperPrevious>
          {{ "back" | translate }}
        </button>
        <button *ngIf="type !== manageBuildingTypes.Details && isAuthorized" color="primary" mat-raised-button
          matStepperNext (click)="confirmAndCreateBuilding()" [disabled]="
            type !== manageBuildingTypes.Details && !profitabilityGroup.valid
          " [mat-dialog-close]="closeMainDialog()">
          {{ "save" | translate }}
        </button>
      </div>
    </div>
  </mat-step>
</mat-horizontal-stepper>
<!-- </div> -->
